// TODO: add the Frame component to the image when it's available

import { Component, Prop, h } from '@stencil/core';

@Component({
  tag: 'cwru-subfeature',
  styleUrl: 'subfeature.css',
  shadow: true,
})
export class Subfeature {
  @Prop() heading: string;
  @Prop() src: string;
  @Prop() alt: string;
  @Prop() href: string = "#";
  @Prop() linktext: string;

  render() {
    if (this.src && !this.alt) console.warn(`Subfeature with heading "${this.heading}" is missing alt text.`)
    return (
      <div class="container">
        {this.src && <cwru-frame><img src={this.src} alt={this.alt} class="image" /></cwru-frame>}
        <div class="content">
          <h2 class="heading">{this.heading}</h2>
          <slot />
        </div>
        <cwru-button href={this.href} width="full">{this.linktext}</cwru-button>
      </div>
    );
  }
}
